import Card from "../../../elements/Card";
import { useParams } from "react-router-dom";
import { ticketDetails } from "../../../../services/ticketService";
import { useQuery } from "@tanstack/react-query";
import ManageAddons from "../../../elements/tabContent/ManageAddons";
import { t } from "i18next";
import { useState } from "react";
import { useSelector } from "react-redux";

const CreateAddons = ({ eventDetails = {} }) => {
  const { addonsId } = useParams();

  const {
    data: addonDetailsData,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ["addon-details", addonsId],
    queryFn: async () => {
      const res = await ticketDetails({ id: addonsId, type: "front" });
      return res;
    },
    enabled: !!addonsId,
  });

  return (
    <div className="bg-white py-4 px-4 rounded-md">
      <Card
        title={t(
          `${
            !addonsId
              ? "Create"
              : addonDetailsData?.data?._id
              ? "Update"
              : "Create"
          } Addon`
        )}
        className=""
        bodyClass="space-y-3"
      >
        <ManageAddons
          eventDetails={eventDetails}
          addonDetailsData={addonDetailsData?.data || {}}
        />
      </Card>
    </div>
  );
};

export default CreateAddons;
